<div class="info-item"  *ngFor="let item of infoItems; trackBy: trackByIndex" [ngClass]="getClass(item)">
  <div [ngClass]="itemClass(item)">
    <div class="info-item__container info-item__container--label">{{item.key}}</div>
    <div class="info-item__container info-item__container--value">
      <ng-container *ngIf="isMixedRetriever(item); else plainValue">
        <span class="badge badge--mixed">{{item.value}}</span>
      </ng-container>
      <ng-template #plainValue>{{item.value}}</ng-template>
    </div>
  </div>
  <div class="special-handling-flag" *ngIf="item.key=='Address:'">
      <app-icon iconStyle="mrcs-icon"
      iconType="mrcs-icon"
      iconName="special-assignment-address"
      *ngIf="!isSpecialHandling"
      title="Enable Special Handling"
      (click)="specialHandling(true)" ></app-icon>
      <app-icon iconStyle="mrcs-icon"
      iconType="mrcs-icon"
      iconName="special-assignment-address active"
      *ngIf="isSpecialHandling"
      title="Edit Special Handling"
      (click)="specialHandling(false)" ></app-icon>
  </div>
</div>
